import React from 'react';
import './SiteFooter.css';
import lysarqLogoImg from '../assets/lysarq-logo.png';

export default function SiteFooter({ onNavigate, currentDistrict }) {
  const handleLink = (e, page, params = {}) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(page, params);
    }
  };

  return (
    <footer className="lysarq-site-footer" role="contentinfo" aria-label="Site Footer and Organization Information">
      <div className="footer-inner-container">
        {/* Main 4-Column Grid */}
        <div className="footer-columns-grid">
          {/* Brand & Organization Entity */}
          <div className="footer-col brand-col">
            <div className="footer-brand-header">
              <img src={lysarqLogoImg} alt="Lysarq Solutions Logo" className="footer-brand-logo" width="32" height="32" />
              <div className="footer-brand-titles">
                <span className="footer-brand-name">LYSARQ MSME</span>
                <span className="footer-brand-sub">Business Intelligence</span>
              </div>
            </div>
            <p className="footer-entity-description">
              Clear market insights, official industry categories, and local growth trends across <strong>7,57,555 registered small businesses</strong> in India. Developed by <strong>Lysarq Solutions</strong>.
            </p>
            <div className="footer-verified-badge">
              <span className="verified-pulse-dot" />
              <span>Official Government Records · India</span>
            </div>
          </div>

          {/* Analytical Workspaces */}
          <div className="footer-col">
            <h4 className="footer-col-title">Pages &amp; Tools</h4>
            <ul className="footer-nav-list">
              <li>
                <a href="/?page=home" onClick={(e) => handleLink(e, 'home')}>
                  Overview
                </a>
              </li>
              <li>
                <a href="/?page=search" onClick={(e) => handleLink(e, 'search')}>
                  Explore &amp; PIN Code Search
                </a>
              </li>
              <li>
                <a href="/?page=trends" onClick={(e) => handleLink(e, 'trends')}>
                  Market Trends
                </a>
              </li>
              <li>
                <a href="/?page=forecast" onClick={(e) => handleLink(e, 'forecast')}>
                  Future Outlook
                </a>
              </li>
              <li>
                <a href="/?page=profile" onClick={(e) => handleLink(e, 'profile')}>
                  My Business Profile
                </a>
              </li>
            </ul>
          </div>

          {/* Authority & Governance (The 5 Core Citable AEO/GEO Pages) */}
          <div className="footer-col">
            <h4 className="footer-col-title">About &amp; Data Sources</h4>
            <ul className="footer-nav-list">
              <li>
                <a href="/?page=about" onClick={(e) => handleLink(e, 'about')}>
                  About Lysarq
                </a>
              </li>
              <li>
                <a href="/?page=methodology" onClick={(e) => handleLink(e, 'methodology')}>
                  How We Collect Data
                </a>
              </li>
              <li>
                <a href="/?page=data-sources" onClick={(e) => handleLink(e, 'data-sources')}>
                  Official Data Sources
                </a>
              </li>
              <li>
                <a href="/?page=data-dictionary" onClick={(e) => handleLink(e, 'data-dictionary')}>
                  Metric Explanations
                </a>
              </li>
              <li>
                <a href="/?page=faq" onClick={(e) => handleLink(e, 'faq')}>
                  Frequently Asked Questions
                </a>
              </li>
            </ul>
          </div>

          {/* Regional Economic Telemetry */}
          <div className="footer-col">
            <h4 className="footer-col-title">Popular Business Districts</h4>
            <ul className="footer-nav-list">
              <li>
                <a href="/?district=coimbatore" onClick={(e) => handleLink(e, 'home', { district: 'coimbatore' })}>
                  Coimbatore MSME Cluster
                </a>
              </li>
              <li>
                <a href="/?district=tirupur" onClick={(e) => handleLink(e, 'home', { district: 'tirupur' })}>
                  Tirupur Apparel Corridor
                </a>
              </li>
              <li>
                <a href="/?district=erode" onClick={(e) => handleLink(e, 'home', { district: 'erode' })}>
                  Erode Agro &amp; Trade Market
                </a>
              </li>
              <li>
                <a href="/?district=palakkad" onClick={(e) => handleLink(e, 'home', { district: 'palakkad' })}>
                  Palakkad Industrial Corridor
                </a>
              </li>
              <li>
                <a href="/?district=kottayam" onClick={(e) => handleLink(e, 'home', { district: 'kottayam' })}>
                  Kottayam Commercial District
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Metadata & Legal Strip */}
        <div className="footer-bottom-strip">
          <div className="footer-bottom-left">
            <span>&copy; {new Date().getFullYear()} <strong>Lysarq Solutions</strong>. All rights reserved.</span>
            <span className="footer-sep">&middot;</span>
            <span>Parent Entity: <a href="https://lysarqsolutions.com/" target="_blank" rel="noopener noreferrer" className="footer-external-link">Lysarq Solutions ↗</a></span>
          </div>
          <div className="footer-bottom-right">
            <span className="footer-security-note">Official Government Registry Records &middot; Privacy Protected &middot; India MSME Insights</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
